import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { Field, Spinner } from "@/components/Field";
import { AuthShell } from "./AuthShell";

export default function LoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      nav(!u.memberships.length && u.platform_role === "super_admin" ? "/piattaforma" : "/");
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Accedi" subtitle="Inserisci il tuo nome utente (o e-mail) e la password.">
      <form onSubmit={submit} className="space-y-4">
        <Field label="Nome utente o e-mail" htmlFor="email"><Input id="email" data-testid="login-email-input" type="text" autoCapitalize="none" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 text-base" /></Field>
        <Field label="Password" htmlFor="password"><Input id="password" data-testid="login-password-input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 text-base" /></Field>
        {error && <p data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</p>}
        <Button data-testid="login-submit-button" type="submit" disabled={busy} className="w-full h-12 text-base font-semibold">{busy ? <Spinner /> : "Accedi"}</Button>
        <Link data-testid="forgot-password-link" to="/password-dimenticata" className="block text-center text-sm font-semibold text-primary hover:underline">Password dimenticata?</Link>
      </form>
    </AuthShell>
  );
}
